// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"9205a125","496":"b50b7e55","498":"4d07eba2","703":"47535699"}[chunkId] + ".chunk.js";
};